import { Component, OnInit } from '@angular/core';
import { PlanogramStateService } from 'src/services/planogram-state.service';
import { Observable, SubscriptionLike } from 'rxjs';
import { ConfirmDialogModalComponent } from '../confirm-dialog-modal/confirm-dialog-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CONFIG } from '../../helper/app-config';
import { PlanogramService } from 'src/services/planogram.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-custom-planogram-library',
  templateUrl: './custom-planogram-library.component.html',
  styleUrl: './custom-planogram-library.component.css',
})
export class CustomPlanogramLibraryComponent implements OnInit {
  custom_planogram_library_subscription: SubscriptionLike;
  custom_planogram_library_observable: Observable<any> =
    this.planogramState.custom_planogram_library_data;
  is_show_loader: Observable<boolean> = this.planogramState.loader;
  columns = ['image', 'details'];
  card_columns = ['name', 'unit', 'channel', 'cooler', 'created on'];
  library_data: any;
  constructor(
    private planogramState: PlanogramStateService,
    private dialog: MatDialog,
    private router: Router,
    private apiService: PlanogramService
  ) {
    this.planogramState.fetchCustomPlanograms();
  }
  ngOnInit(): void {
    this.customPlanogramLibraryDataSubscription();
  }

  customPlanogramLibraryDataSubscription() {
    this.custom_planogram_library_observable.subscribe((res) => {
      this.library_data = res.filter(
        (data: any) => data.progress_status == 'Completed'
      );
      this.library_data = this.library_data.map((data: any) => {
        if (data.planogram_image_uri.includes(environment.picturesAccount)) {
          this.apiService
            .fetchImageFromBlob(data.planogram_image_uri)
            .subscribe({
              next: (res: any) => {
                const imageUrl = URL.createObjectURL(res);
                data.imageUrl = imageUrl;
              },
              error: (error) => {
                console.log('Error fetching image:', error);
              },
            });
        }
        return data
      });
    });
  }

  handleDeleteClick = (event: any, planogram_id: number) => {
    event.stopPropagation();
    const dialogRef = this.dialog.open(ConfirmDialogModalComponent, {
      height: '200px',
      width: '500px',
      data: {
        header_msg: 'Are you sure you want to delete?',
        header_msg_description: 'This action cannot be undone.',
        cancel_action: 'Cancel',
        ok_action: 'Continue',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (planogram_id !== undefined) {
          this.planogramState.deletePlanogram(planogram_id);
        }
      }
    });
  };

  editPlanogram(planogram_id: number) {
    this.planogramState.getPlanogramSavedData(planogram_id);
    this.router.navigateByUrl(
      CONFIG.PATH.ADMIN_CUSTOM_PLANOGRAM + planogram_id,
      { state: { screen_index: 1 } }
    );
  }

  moveToLibrary() {
    this.router.navigateByUrl(CONFIG.PATH.LANDING_PAGE);
  }
}
